/*
 * @Description:
 * @Date: 2019-04-28 13:17:06
 */

import dateFormat from '@/tools/dateFormat.js';
import querystring from 'querystring';
import Config from '@/config/index';
import echarts from 'echarts';
import * as math from 'mathjs';
import { v4 as uuidv4 } from 'uuid';
import xrkDialogJs from '@/components/Dialog/main.js';
import xrkDialogComponent from '@/components/Dialog/main.vue';
import { makeSure } from '@/tools/index';
import * as methods from '@/methods/index';
import * as directives from '@/directives/index';
import sa from '@/public/sa';
import installSentry from './sentry';
import router from '../router/index';

const download = require('downloadjs');

export default {
  install(Vue) {
    Vue.prototype.$sentry = installSentry(Vue, router);
    Vue.prototype.$dateFormat = dateFormat;
    Vue.prototype.$qiniuPath = 'http://cdn1.yxvzb.com/';
    Vue.prototype.$querystring = querystring;
    Vue.prototype.$Config = Config;
    Vue.prototype.$echarts = echarts;
    Vue.prototype.$uuidv4 = uuidv4;
    Vue.prototype.$math = math;
    Vue.prototype.$xrkDialog = xrkDialogJs;
    Vue.prototype.$makeSure = makeSure;
    Vue.prototype.$download = download;
    Vue.prototype.$sa = new sa();
    Object.keys(methods).forEach(key => {
      Vue.prototype[`$${key}`] = methods[key];
    });
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key]);
    });
    Vue.component(xrkDialogComponent.name, xrkDialogComponent);
  }
  // $http: axios
};
